import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'
import GettingStarted from '@segment/templates/GettingStarted'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import CreateSharedData from './components/CreateSharedData/CreateSharedData'
import DiagnoseDataQualityIssues from './components/DiagnoseDataQualityIssues'
import Testimonials from './components/Testimonials'
import FaqSection from './components/FaqSection'

import ogImagePng from './assets/OgProtocols.png'

const ProtocolsView = () => (
  <AppearanceProvider appearance="twilioLight">
    <Layout
      pageTitle="Protocols: Customer Data Validation Tool | Twilio Segment"
      pageDescription="Protocols offers enterprise level data cleaning and standardization to give you control over your data quality with real-time data validation."
      pageOG={ogImagePng}
    >
      <NavigationV2 />
      <Hero />
      <Main>
        <CreateSharedData />
        <DiagnoseDataQualityIssues />
        <Testimonials />
        <FaqSection />
        <GettingStarted />
      </Main>
      <Footer />
    </Layout>
  </AppearanceProvider>
)

const Main = styled.main`
  overflow-x: hidden;
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default ProtocolsView
